<div class="backdrop">
  <div class="box flex flex-col items-center justify-center">
    <p class="text-white mb-4">Sembra che tu non sia autorizzato all'accesso di questa pagina.</p>
    <p-button class="ze-btn outline" label="Torna al login" (click)="logout()"></p-button>
  </div>
</div>
